// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.22.12';
//# sourceMappingURL=version.js.map